import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { StoreDto, TeamDto } from '@/infra/api/generated/model'

type UserPreferencesState = {
  store?: StoreDto
  team?: TeamDto
  languageId?: number
  upsertStore: (store: StoreDto | undefined) => void
  upsertTeam: (team: TeamDto | undefined) => void
  upsertLanguageId: (languageId: number) => void
  reset: () => void
}

const STORAGE_KEY = 'userPreferences'
const STORAGE_VERSION = 1

export const useUserPreferences = create<UserPreferencesState>()(
  persist(
    (set) => ({
      store: undefined,
      team: undefined,
      languageId: undefined,
      upsertStore: (store) => set(() => ({ store, team: undefined })),
      upsertTeam: (team) => set(() => ({ team })),
      upsertLanguageId: (languageId) => set(() => ({ languageId })),
      reset: () => set(() => ({ store: undefined, team: undefined, languageId: undefined })),
    }),
    {
      name: STORAGE_KEY,
      version: STORAGE_VERSION,
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ store: s.store, team: s.team, languageId: s.languageId }),
    }
  )
)
